import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgContactsmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.286 9.398c.293-.322.456-.743.455-1.18 0-.966-.78-1.75-1.741-1.75-.96 0-1.74.784-1.74 1.75 0 .455.171.868.454 1.18a2.47 2.47 0 0 0-1.166 1.97.125.125 0 0 0 .125.132h.686a.125.125 0 0 0 .124-.117 1.53 1.53 0 0 1 1.519-1.414c.8 0 1.459.625 1.518 1.414a.125.125 0 0 0 .124.117h.684a.124.124 0 0 0 .117-.082.124.124 0 0 0 .008-.05 2.47 2.47 0 0 0-1.167-1.97ZM8 9.031a.81.81 0 0 1-.808-.812A.81.81 0 0 1 8 7.406a.81.81 0 0 1 .808.813A.81.81 0 0 1 8 9.03ZM14.5 3.5H12v-.875a.125.125 0 0 0-.125-.125H11a.125.125 0 0 0-.125.125V3.5H8.562v-.875a.125.125 0 0 0-.124-.125h-.876a.125.125 0 0 0-.125.125V3.5H5.126v-.875A.125.125 0 0 0 5 2.5h-.875A.125.125 0 0 0 4 2.625V3.5H1.5A.5.5 0 0 0 1 4v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5Zm-.625 8.875H2.125v-7.75H4V5.5c0 .069.056.125.125.125H5a.125.125 0 0 0 .125-.125v-.875h2.313V5.5c0 .069.056.125.125.125h.875a.125.125 0 0 0 .124-.125v-.875h2.313V5.5c0 .069.056.125.125.125h.875A.125.125 0 0 0 12 5.5v-.875h1.875v7.75Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgContactsmin);
export { ForwardRef as ReactComponent };
